const UNAUTHORIZED = 401;

export const SIGNED_IN_PATHS = Object.freeze([
  "/account-dashboard",
  "/account/referral",
  "/dashboard",
]);

export const signInPathFor = ({ pathname, search = "", hash = "" }) =>
  `/login?${new URLSearchParams({ r: `${pathname}${search}${hash}` })}`;

export const isSignedOut = ({ data, error }) =>
  error?.status === UNAUTHORIZED || (Boolean(data) && !data.data?.user_id);
